import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './InvitationItemPage.module.scss';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button, ConfirmModal, openNotification } from 'tt-ui-lib/core';
import { useWindowSize } from '../../utils/useWindowSize';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_INVITATION_BY_ID, WITHDRAW_INVITATION } from '../../api';
import {
  invitationStatusColors,
  invitationStatuses,
} from '../CommunityPage/MyCommunity/Invitations/invitationStatuses';
import moment from 'moment';

const InvitationItemPage = () => {
  const [invitationData, setInvitationData] = useState({});
  const [openWithdrawModal, setOpenWithdrawModal] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [getInvitation] = useLazyQuery(GET_INVITATION_BY_ID);
  const [withdrawInvitation] = useMutation(WITHDRAW_INVITATION);
  const windowSize = useWindowSize();

  const getInvitationList = async () => {
    const res = await getInvitation({
      variables: {
        id: id,
      },
      fetchPolicy: 'network-only',
    });
    if (res.data && res.data.getInvitationById) {
      setInvitationData(res.data.getInvitationById);
    } else {
      setNotFound(true);
    }
  };

  const handleWithdrawInvitation = async () => {
    const res = await withdrawInvitation({
      variables: {
        id: id,
      },
    });
    if (res.data && res.data.withdrawInvitation) {
      openNotification({
        message: 'Invitation withdrawn successfully',
        type: 'success',
      });
      setInvitationData((current) => ({ ...current, status: res.data.withdrawInvitation.status }));
    } else {
      openNotification({
        message: 'Something went wrong, please try again',
        type: 'error',
      });
    }
    setOpenWithdrawModal(false);
  };

  useEffect(() => {
    (async () => {
      if (id) {
        await getInvitationList();
      }
    })();
  }, [id]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className={styles.pageContent}>
        {notFound ? (
          <div className={styles.mainTitle} style={{ textAlign: 'center !important' }}>
            Invitation not found
          </div>
        ) : (
          <>
            <div className={styles.headerActions}>
              <div className={styles.invitationNumber}>
                <ArrowBackIosIcon onClick={() => goBack()} className={styles.backButton} />
                <div className={styles.mainTitle}>Invitation №{id}</div>
              </div>
              {invitationData.status === 0 && (
                <>
                  {windowSize.width > 700 ? (
                    <Button
                      type="link"
                      className={styles.withdrawBtn}
                      disableRipple
                      onClick={() => setOpenWithdrawModal(true)}
                    >
                      <img src="/images/undo.svg" alt="" style={{ width: 24, height: 24 }} />
                      withdraw the invitation
                    </Button>
                  ) : (
                    <Button
                      type="link"
                      className={styles.withdrawBtn}
                      disableRipple
                      onClick={() => setOpenWithdrawModal(true)}
                    >
                      <img src="/images/undo.svg" alt="" style={{ width: 24, height: 24 }} />
                    </Button>
                  )}
                </>
              )}
            </div>
            {invitationData?.role?.name && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>Role</div>
                <div className={styles.infoItemValue} style={{ textTransform: 'capitalize' }}>
                  {invitationData.role.name}
                </div>
              </div>
            )}
            {(invitationData.status || invitationData.status === 0) &&
              invitationStatuses[invitationData.status] && (
                <div className={styles.infoItem}>
                  <div className={styles.infoItemTitle}>Status</div>
                  <div
                    style={{ color: `${invitationStatusColors[invitationData.status]} !important` }}
                    className={styles.infoItemValueStatus}
                  >
                    {invitationStatuses[invitationData.status]}
                  </div>
                </div>
              )}
            {invitationData.created_at && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>Invitation date</div>
                <div className={styles.infoItemValue}>
                  {moment(invitationData.created_at).format('DD/MM/YYYY')}
                </div>
              </div>
            )}
            {invitationData.first_name && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>First name</div>
                <div className={styles.infoItemValue}>{invitationData.first_name}</div>
              </div>
            )}

            {invitationData.last_name && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>Last name</div>
                <div className={styles.infoItemValue}>{invitationData.last_name}</div>
              </div>
            )}
            {invitationData.email && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>E-mail</div>
                <div className={styles.infoItemValue}>{invitationData.email}</div>
              </div>
            )}
            {invitationData.comment && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>Comment for the invitee</div>
                <div className={[styles.infoItemValue, styles.wrapValue]}>
                  {invitationData.comment}
                </div>
              </div>
            )}
            {invitationData.note && (
              <div className={styles.infoItem}>
                <div className={styles.infoItemTitle}>My notes</div>
                <div className={[styles.infoItemValue, styles.wrapValue]}>
                  {invitationData.note}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {/* <div className={styles.buttons}>
        <Button type="primary" className={styles.sendBtn
          <SendIcon />
          Re-invite
        </Button>
      </div> */}
      <ConfirmModal
        open={openWithdrawModal}
        title={`Withdraw the invitation № ${id}`}
        subTitle="Do you really want to withdraw the invitation?"
        okText="To withdraw"
        onConfirm={() => handleWithdrawInvitation()}
        onClose={() => setOpenWithdrawModal(false)}
      />
    </>
  );
};
export default InvitationItemPage;
